import React, { useEffect } from 'react';
import { connect, ConnectedProps, useDispatch, useStore } from 'react-redux';
import { Dispatch } from 'redux';
import { GeneralAdsPage } from '../../GeneralAdsPage';
import {
  setAdriverSelectedCity,
  setCurrentState,
  setError,
  setSearchSort
} from '../../../actions';
import { BUILDING_TYPE_ID, Cities } from '../../../utils/helpers/constants';
import { ItemConnectionSort } from '../../../graphql/types';

interface ItemsAllProps {
  sortingValue?: string;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setErrorUI: (errorState: boolean) => dispatch(setError(errorState))
});

const connector = connect(null, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type CombinedProps = ItemsAllProps & PropsFromRedux;

const ItemsAllComponent: React.FC<CombinedProps> = ({
  sortingValue,
  setErrorUI
}) => {
  const dispatch = useDispatch();
  const store = useStore();

  useEffect(() => {
    const storedFormState = store.getState()?.searchForm?.currentState;
    dispatch(
      setCurrentState({
        ...storedFormState,
        city_id: Cities.Baku.id,
        category_id: BUILDING_TYPE_ID.FLAT_ALL,
        leased: 'false',
        sorting: sortingValue
      })
    );
    dispatch(setAdriverSelectedCity(Cities.Baku.az));
    dispatch(setSearchSort(sortingValue || ItemConnectionSort.BumpedAtDesc));
  }, [sortingValue]);

  return (
    <GeneralAdsPage
      transformedObj={{ sorting: sortingValue, filter: {} }}
      setErrorUI={setErrorUI}
    />
  );
};

export const ItemsAll = connector(ItemsAllComponent);
